import AttToken from '../../services/AttToken'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify';
import queryClient from '../../services/query';
import Users from '../../services/User';
import { Button, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import GenericAutoComplete from '../AutocompleteGenerico';

const userService = new Users();




type userProps = {
  openModal: boolean,
  setOpenModal: Function,
  user: any,
  setUser: Function,
  empresas: any[]
  isLoading: boolean,
}

export default function AddEmpresasModal({
  openModal,
  setOpenModal,
  user,
  setUser,
  empresas,
  isLoading
}: userProps) {

  const { mutate, isLoading: loadingChange } = useMutation({
    mutationKey: ['CHANGE_USER'],
    mutationFn: async () => {
      try {
        toast.warn('Salvando!')
        const token = await AttToken()
        if (token) {
          const response = await userService.editUser(token, user?.id, user)
          return response
        }
      } catch (err) {
        toast.error('Erro ao salvar')
      }
    },
    onSuccess: () => {
      queryClient.resetQueries(['GET_USERS'])
      setOpenModal(!openModal)
      toast.success('Salvo com sucesso!')
    }
  })

  return (
    <Dialog
      onClose={() => setOpenModal(!openModal)}
      aria-labelledby="customized-dialog-title"
      open={openModal}
    >
      <DialogTitle sx={{ m: 0, p: 2, width: '500px' }} id="customized-dialog-title">
        Adicionar empresas para: "{user.nome}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpenModal(!openModal)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Stack direction='column' spacing={2} alignItems='baseline' justifyContent='flex-start' padding={2}>
          <GenericAutoComplete
            loading={isLoading}
            options={empresas?.map((e: any) => ({ label: e.nome, value: e.id, key: e })) ?? []}
            selectedValues={user.empresas?.map((empresa: any) => (empresa)) || []}
            onChange={(values) => {
              setUser({ ...user, empresas: values });
            }}

            label='Empresas adicionadas'
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => mutate()} disabled={loadingChange}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
